const wizardLoggerEnabled = false;
const noop = () => {};

export const productWizardConsole = new Proxy<typeof console>({} as typeof console, {
  get: (_target, key: keyof typeof console) => {
    if (wizardLoggerEnabled && typeof window !== 'undefined') {
      return console[key];
    }
    return noop;
  },
});
